import requests from "./httpService";

const DropDownService = {
    employeeDropDown: async () => {
        return requests.post(`/employee/dropdown`);
    },
    getDepartmentDropDown: async (body) => {
        return requests.post("/department/drop-down", body);
    },
    projectDropDown: async () => {
        return requests.post("/project/drop-down");
    },
    clientDropDown: async () => {
        return requests.post("/client/drop-down");
    },
    getModulePermissions: async (body) => {
        return requests.post("/module/permission", body);
    },
    clientProjectDropDown: async () => {
        return requests.get("/clientPortal/getProjects");
    },
};

export default DropDownService; 